export const DEFAULT_PAGE_VIEW_EVENT = 'page_view';
